import type { ReactElement } from 'react';
import { useSession } from '../../auth';
import { Link } from './Link';
import { ActionArrow } from './ActionArrow';
import './BackgroundRow.css';

/**
 * The "Informing Ember" state line (2026-09-12 data contract; the user-facing
 * layer never says "Background experience"), at the Result's foot — the voice
 * telling's landing, where a guest with no Settings may stand. It is state
 * made visible, not a question: the account-wide switch is in Settings —
 * `Change` goes there. (Until 2026-09-12 also under the owner's Ember page
 * blocks; the Ember's own switch replaced it there, §4.13.)
 * This is the layer where eligible Embers, with identifying details removed,
 * inform what Ember tells people who ask about similar situations at a light; it never lets
 * anyone read the Ember — another person reads it only after Ember asked the
 * teller and they said yes (§4.9), which is what the second sentence says
 * every time.
 * A guest has no Settings and carries the default, on.
 */
export function BackgroundRow({ emberId }: { emberId: string }): ReactElement {
  const on = useSession().session?.background_experience ?? true;
  return (
    <section className="matching-row" aria-label={`Helping Ember understand similar situations · ${on ? 'On' : 'Off'}`}>
      <p className="matching-row-title">Helping Ember understand similar situations · {on ? 'On' : 'Off'}</p>
      <p className="matching-row-help">
        {on
          ? 'With identifying details removed, this Ember may inform what Ember says to people in a similar place, in conversation and on a light’s public page. No one can read your Ember unless you separately say yes.'
          : 'Your experience doesn’t inform what Ember tells other people.'}
      </p>
      <div className="matching-row-actions">
        <Link to="/settings" className="ember-text-action matching-row-action" data-log="background_change_open" data-log-ember-id={emberId}>
          Change <ActionArrow />
        </Link>
      </div>
    </section>
  );
}
